import useApi from "@/hooks/useApi";
import { LoadingSpinner } from "@velaro/velaro-component-lib";
import * as React from "react";
import { useEffect, useState } from "react";
import { UploadedFile } from "./types";
import UploadedFileEditor from "./UploadedFileEditor";
import Panel from "@/components/Panel";
import useToastAlert from "@/hooks/useToastAlert";
import { Severity } from "@velaro/velaro-component-lib";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import FileUpload from "../../../components/FileUpload/FileUpload";
import FilesEditor from "@/components/FileUpload/FilesEditor";

export default function FileStorage() {
  const [files, setFiles] = useState<UploadedFile[]>([]);
  const [newFiles, setNewFiles] = useState<File[]>([]);
  const [loading, setLoading] = useState(true);
  const toast = useToastAlert();
  const api = useApi();

  async function save() {
    setLoading(true);
    const formData = new FormData();

    for (const file of newFiles) {
      formData.append("files", file);
    }
    formData.append("type", "General");

    const result = await api.messaging.postFormData("uploadedFiles", formData);
    if (result.status !== 200) {
      setLoading(false);
      toast.displayToast(
        Severity.Error,
        "Error uploading files: " + (await result.text())
      );
      return;
    }

    setFiles([...files, ...(await result.json())]);
    setNewFiles([]);
    toast.displayToast(Severity.Success, "Files uploaded successfully");
    setLoading(false);
  }

  async function remove(file: UploadedFile) {
    await api.messaging.delete("uploadedFiles", { id: file.id });
    const clone = [...files];
    clone.splice(files.indexOf(file), 1);
    setFiles(clone);
  }

  useEffect(() => {
    async function fetchFiles() {
      const response = await api.messaging.get(
        `uploadedFiles/list/${"General"}`
      );
      setFiles(await response.json());
      setLoading(false);
    }

    fetchFiles();
  }, [api.messaging]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <FileUpload
        onAddFiles={(files) => setNewFiles((s) => [...s, ...files])}
        multiple
      >
        <div className="flex flex-row text-slate-500 text-xs">
          You can upload a maximum of 5 files at once, with each file not
          exceeding 20 MB.
        </div>
      </FileUpload>
      <FilesEditor files={newFiles} onUpdate={setNewFiles} />
      <div className="m-4">
        <span className="flex items-center justify-end">
          <PrimaryBlueButton label="Save" onClick={save} />
        </span>
      </div>

      <Panel title={"Uploaded"}>
        <div className="p-4">
          <UploadedFileEditor files={files} onRemove={remove} />
        </div>
      </Panel>
    </>
  );
}
